<template>
  <el-dialog
    :id="$options.name"
    :before-close="noDialog"
    :fullscreen="dialogFullscreen"
    :visible.sync="dialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    title="退单弹窗"
  >
    <div>确定退单吗?</div>
    <div slot="footer">
      <el-button @click="noDialog">取消</el-button>
      <el-button type="primary" @click="finish">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import dialogMixin from "@/mixin/dialogMixin";
import timeMixin from "@/mixin/timeMixin";
import resDisposeMixin from "@/mixin/resDisposeMixin";
import agentRefundParkingOrder from "@/api/fund/order-manage/agentRefundParkingOrder";

export default {
  name: "refundParkingOrderDialog",
  mixins: [dialogMixin, timeMixin, resDisposeMixin],
  props: {
    id: Number,
  },
  watch: {
    id(newValue) {
      // eslint-disable-next-line vue/no-mutating-props
      this.id = newValue;
    },
  },
  methods: {
    finish() {
      this.loadStart();
      agentRefundParkingOrder(this.id)
        .then((res) => {
          this.resNoDialog({ res });
        })
        .finally(() => {
          this.loadDialog.close();
        });
    },
  },
};
</script>
